import React from "react";
import InboxIcon from "@mui/icons-material/Inbox";
import Button from "./Button.tsx";

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, actionLabel, onAction, icon }) => (
  <div className="ds-empty-state">
    <div className="icon-xl" style={{ display: "flex", justifyContent: "center" }}>
      {icon ?? <InboxIcon sx={{ fontSize: 40 }} />}
    </div>
    <h3>{title}</h3>
    {description && <p>{description}</p>}
    {actionLabel && onAction && (
      <Button variant="primary" size="sm" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
